<template>
  <v-dialog v-model="modelAjuda" width="800px" v-on:update:modelValue="fechar">
    <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card>
      <v-card-title class="pa-6 text-xlarge">
        {{ titulo }}
      </v-card-title>
      <v-card-text class="pa-6 pt-0 text-color-0">
        <div v-if="texto != ''" v-html="texto"></div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'DialogAjuda',
  data(){
    return {
      modelAjuda: false,
      titulo: "",
      texto: ""
    }
  },
  props: {
    ajuda: {
      type: Number,
      default: null
    },
    model: {
      type: Boolean,
      default: false
    },
    fechar: {
      type: Function,
      default: null
    }
  },
  watch: {
    model() {
      this.modelAjuda = this.model;
    },
    ajuda(value){
      if(value != null){
        this.getPolicy(value).then(function(response){
          this.texto = response;
        }.bind(this));
        switch(value){
          case 7:
            this.titulo = "Como funciona?";
          break;
          case 8:
            this.titulo = "Dúvidas frequentes";
          break;
          case 9:
            this.titulo = "Entre em contato";
          break;
          case 10:
            this.titulo = "Política de Privacidade";
          break;
        }
      } else {
        this.titulo = "";
        this.texto = "";
      }
    }
  },
  methods: {
    ...mapActions('main', {
      getPolicy: 'getPolicy'
    }),
  }
}
</script>